import { render, staticRenderFns } from "./PosProductPicker.vue?vue&type=template&id=19afbf55&"
import script from "./PosProductPicker.vue?vue&type=script&lang=js&"
export * from "./PosProductPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports